import { IkasCampaignOfferProduct } from "./product";

export type IkasCampaignOffer = {
  availableSalesChannelIds: string[];
  endDate: any | null;
  followUpActionType: IkasCampaignOfferFollowUpActionType;
  minimumRequiredCartAmount: number | null;
  name: string;
  offers: IkasCampaignOfferProduct[];
  startDate: any | null;
  targetPageTypes: IkasCampaignOfferTargetPageType[];
  triggerSettings: IkasCampaignOfferTriggerSettings;
  type: IkasCampaignOfferType;
};

export type IkasCampaignOfferTriggerSettings = {
  filterType: IkasCampaignOfferTriggerFilterType;
  valueList: string[];
};

export enum IkasCampaignOfferFollowUpActionType {
  DO_NOTHING = "DO_NOTHING",
  OPEN_CART = "OPEN_CART",
  OPEN_CHECKOUT = "OPEN_CHECKOUT",
}

export enum IkasCampaignOfferTargetPageType {
  CHECKOUT = "CHECKOUT",
  POST_CHECKOUT = "POST_CHECKOUT",
}

export enum IkasCampaignOfferType {
  CROSS_SELL = "CROSS_SELL",
  UPSELL = "UPSELL",
}

export enum IkasCampaignOfferTriggerFilterType {
  ALL_PRODUCTS = "ALL_PRODUCTS",
  CATEGORY = "CATEGORY",
  PRODUCT = "PRODUCT",
  PRODUCT_TAG = "PRODUCT_TAG",
  VARIANT = "VARIANT",
}
